import PropTypes from 'prop-types';
import React from 'react';
import RouteActions from '@get-bridge/learn-legacy-shared/dist/core/RouteActions';

export default class LinkInterceptor extends React.Component {
  static propTypes = {
    children: PropTypes.node.isRequired,
  };

  static childContextTypes = {
    bgn_applyCustomLinkTransition: PropTypes.func,
  };

  getChildContext() {
    return {
      bgn_applyCustomLinkTransition: this.applyTransition,
    };
  }

  render() {
    return React.Children.only(this.props.children);
  }

  applyTransition = e => {
    const { currentTarget } = e;
    if (currentTarget.target === '_blank') return;

    e.preventDefault();

    /*
      When linking to a suite URL,
      (anything behind the js runtime - Perform, Career, Holly, Engage)
      don't use Learn's routing mechanism,
      instead just directly set the new url since we'll have to do a full page reload anyway
      to boot the js runtime.
    */
    const isSameDomain = currentTarget.href.startsWith(window.location.origin);
    if (isSameDomain) {
      RouteActions.transitionTo(
        currentTarget.pathname + currentTarget.search,
      );
    } else {
      window.location.assign(currentTarget.href);
    }
  };
}



// WEBPACK FOOTER //
// ./packages/bridge-global-nav/src/LinkInterceptor.js